import React, { useEffect, useState, useRef } from 'react';
import Modal from '../../../../templates/contents/Modal';
import Container from '@material-ui/core/Container';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import DataProvider from '../../../../provider';
import { useHistory, useLocation } from 'react-router-dom';
import { client, applePay } from 'braintree-web';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CrossStoreType, setKey } from '../../../../cross-store';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { pushTrackingEvent } from '../../../../utils/gtmDataLayer';

const BUTTON_ID = 'apple-pay-button';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
    height: '100%',
    width: '100%'
  },
  button: {
    width: '70%',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonPlaceholder: {
    width: '70%'
  },
  text: {
    margin: theme.spacing(0, 0, 4),
  },
  errorButton: {
    margin: theme.spacing(0, 0, 1),
  },
  errorButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '70%',
    margin: theme.spacing(4, 0, 0),
  }
}));

export default (props) => {
  const history = useHistory();
  const classes = useStyles();

  const [nonce, setNonce] = useState<string>();
  const [clientToken, setClientToken] = useState<any | null>(null);

  const [status, setStatus] = useState<
    | 'INITIAL'
    | 'FETCH_TOKEN'
    | 'FETCHING_TOKEN'
    | 'ERROR_FETCHING_TOKEN'
    | 'CREATE_CLIENT'
    | 'CREATING_CLIENT'
    | 'ERROR_CREATING_CLIENT'
    | 'CLIENT_CREATED'
    | 'SEND_NONCE'
    | 'SENDING_NONCE'
    | 'ERROR_SENDING_NONCE'
    | 'ERROR_SUPPORTED_DEVICE'
  >('INITIAL');

  const [errorSendingNonce, setErrorSendingNonce] = useState<string>("C'è stato un errore. Riprova o contattaci al +390289763305 (Gateway error: 20142)");
  const applePayButton = useRef<HTMLDivElement | null>(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const return_url = searchParams.get('return-url');
  const key_to_update: CrossStoreType = searchParams.get('key-to-update') as CrossStoreType;

  useEffect(() => {
    if (status === 'INITIAL') {
      setStatus('FETCH_TOKEN');
    }

    if (status === 'FETCH_TOKEN') {
      setStatus('FETCHING_TOKEN');

      const dataProvider = DataProvider(process.env.REACT_APP_WAREHOUSE_API || '');
      dataProvider('b2c/payment/integration/braintree/token')
        .then((clientToken) => {
          setClientToken(clientToken);
          setStatus('CREATE_CLIENT');
        })
        .catch((e) => {
          e &&
            pushTrackingEvent({
              type: 'TrackingEvent',
              data: {
                category: 'error-apple-pay-add',
                action: 'getting_token',
                label: JSON.stringify(e)
              }
            });
          setStatus('ERROR_FETCHING_TOKEN');
        });
    }

    if (status === 'CREATE_CLIENT' && clientToken) {
      setStatus('CREATING_CLIENT');

      client
        .create({ authorization: clientToken.clientToken })
        .then((clientInstance) => applePay.create({ client: clientInstance }))
        .then((applePayInstance) => {
          // @ts-ignore
          const sessionAvailable = window.ApplePaySession && window.ApplePaySession.canMakePayments();
          // @ts-ignore
          if (!window.ApplePaySession) {
              console.error('This device does not support Apple Pay');
          }
          // @ts-ignore
          if (!window.ApplePaySession.canMakePayments()) {
              console.error('This device is not capable of making Apple Pay payments');
          }

          if (!sessionAvailable) {
            setStatus('ERROR_CREATING_CLIENT');
            return;
          }

          const button = document.createElement('button');
          button.id = BUTTON_ID;
          button.style.width = '100%';
          button.style.height = '48px';
          button.style.borderRadius = '8px';
          button.style.webkitAppearance = '-apple-pay-button';
           //@ts-ignore
          button.style.applePayButtonType = 'plain';
          //  @ts-ignore
          button.style.applePayButtonStyle = 'black';

          button.onclick = () => {
            const paymentRequest = applePayInstance.createPaymentRequest({
              total: {
                label: 'Foorban',
                amount: '0.00'
              },
              currencyCode: 'EUR',
              supportedNetworks: ['visa', 'masterCard'],
              merchantCapabilities: ['supports3DS'],
            });

             //@ts-ignore
            const session = new window.ApplePaySession(3, paymentRequest);

            session.onvalidatemerchant = (event) => {
              applePayInstance.performValidation({ validationURL: event.validationURL, displayName: 'Foorban' })
                .then((merchantSession) => session.completeMerchantValidation(merchantSession))
                .catch((e) => {
                  pushTrackingEvent({
                    type: 'TrackingEvent',
                    data: {
                      category: 'error-apple-pay-add',
                      action: 'merchant_validation',
                      label: JSON.stringify(e)
                    }
                  });
                  session.abort();
                });
            };

            session.onpaymentauthorized = (event) => {
              applePayInstance.tokenize({ token: event.payment.token })
                .then((payload) => {
                  setNonce(payload.nonce);
                  setStatus('SEND_NONCE');
                  // @ts-ignore
                  session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                })
                .catch((e) => {
                  pushTrackingEvent({
                    type: 'TrackingEvent',
                    data: {
                      category: 'error-apple-pay-add',
                      action: 'tokenization',
                      label: JSON.stringify(e)
                    }
                  });
                  // @ts-ignore
                  session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                });
            };

            session.begin();
          };

          if (applePayButton.current) {
            applePayButton.current.innerHTML = '';
            applePayButton.current.appendChild(button);
          }

          setStatus('CLIENT_CREATED');
        })
        .catch((e) => {
          e &&
            pushTrackingEvent({
              type: 'TrackingEvent',
              data: {
                category: 'error-apple-pay-add',
                action: 'creating_client',
                label: JSON.stringify(e)
              }
            });
          setStatus('ERROR_CREATING_CLIENT');
        });
    }

    if (status === 'SEND_NONCE' && nonce) {
      setStatus('SENDING_NONCE');

      const dataProvider = DataProvider(process.env.REACT_APP_WAREHOUSE_API || '');
      dataProvider('b2c/payment/integration/braintree/braintree-applepay-pi/add-account', {
        method: 'POST',
        body: JSON.stringify({ nonce })
      })
        .then((paymentInstrument) => {
          if (history.location.state && history.location.state['key_to_update']) {
            setKey(history.location.state['key_to_update'], paymentInstrument);
          } else if (key_to_update) {
            setKey(key_to_update, paymentInstrument);
            if (return_url) {
              history.replace(decodeURIComponent(return_url));
              return;
            }
          }

          history.goBack();
        })
        .catch((e) => {
          e &&
            pushTrackingEvent({
              type: 'TrackingEvent',
              data: {
                category: 'error-apple-pay-add',
                action: 'sending_nonce',
                label: JSON.stringify(e)
              }
            });

          if (e && e.message) setErrorSendingNonce(e.message);

          setStatus('ERROR_SENDING_NONCE');
        });
    }
  }, [status, clientToken, nonce, applePayButton, history, key_to_update, return_url]);

  useEffect(() => {
    const isSafari = () => {
      const ua = navigator.userAgent;
      const isWebKit = /AppleWebKit/.test(ua);
      const isChrome = /Chrome|CriOS/.test(ua);
      const isFirefox = /FxiOS/.test(ua);
  
      // @ts-ignore
      return isWebKit && !isChrome && !isFirefox && !!window.ApplePaySession;
    };
  
    if(!isSafari()) {
      setStatus('ERROR_SUPPORTED_DEVICE');
    }
  },[])

  return (
    <Modal title="Collega Apple Pay" action={history.goBack}>
      <Container className={classes.container} component="main" maxWidth="xs">
        
        {['ERROR_SENDING_NONCE'].includes(status) && (
          <Alert severity="error">{errorSendingNonce}</Alert>
        )}

        {['ERROR_FETCHING_TOKEN', 'ERROR_CREATING_CLIENT'].includes(status) && (
          <Alert severity="error">
            C'è stato un errore. Riprova o contattaci al +390289763305 (Gateway error: 20144)
          </Alert>
        )}

        {['ERROR_SUPPORTED_DEVICE'].includes(status) && (
          <>
            <Alert severity="error">
              Questo browser non supporta Apple Pay.
            </Alert>
            <div className={classes.errorButtonContainer}>
              <Button variant="outlined" onClick={history.goBack}>
                indietro
              </Button>
            </div>
          </>
        )}

        {['ERROR_FETCHING_TOKEN', 'ERROR_CREATING_CLIENT', 'ERROR_SENDING_NONCE'].includes(status) && (
          <div className={classes.errorButtonContainer}>
            <Button
              color="primary"
              className={classes.errorButton}
              onClick={() => {
                if (applePayButton.current) {
                  applePayButton.current.innerHTML = '';
                }
                setStatus('INITIAL');
              }}
              variant="contained"
              size="large"
            >
              Riprova
            </Button>
            <Button variant="outlined" onClick={history.goBack}>
              indietro
            </Button>
          </div>
        )}

        {[
          'INITIAL',
          'FETCH_TOKEN',
          'FETCHING_TOKEN',
          'CREATE_CLIENT',
          'CREATING_CLIENT',
          'CLIENT_CREATED',
          'SENDING_NONCE'
        ].includes(status) && (
          <Typography align="center" className={classes.text}>
            Clicca qui per aggiungere Apple Pay al tuo profilo Foorban.
          </Typography>
        )}

        <div
          ref={applePayButton}
          style={{ display: status === 'CLIENT_CREATED' ? 'flex' : 'none' }}
          className={classes.button}
          id={BUTTON_ID}
        ></div>

        {[
          'INITIAL',
          'FETCH_TOKEN',
          'FETCHING_TOKEN',
          'CREATE_CLIENT',
          'CREATING_CLIENT',
          'SENDING_NONCE'
        ].includes(status) && (
          <Button className={classes.buttonPlaceholder} variant="contained" size="large">
            <CircularProgress style={{ width: '28px', height: '28px' }} color="inherit" />
          </Button>
        )}
      </Container>
    </Modal>
  );
};
